module.exports = __webpack_public_path__ + "img/1.73b1284c.png";